var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VFlex',{staticClass:"resto-byline",attrs:{"mt-4":"","text-xs-center":"","white--text":""}},[_vm._v("Website & Menus Powered by "),_c('a',{style:(_vm.linkStyles),attrs:{"href":"https://getresto.com","target":"_blank"}},[_vm._v("Resto")])])
}
var staticRenderFns = []

export { render, staticRenderFns }